import React from 'react';
import UserAvatar from 'components/pure/utils/UserAvatar';
import classnames from 'classnames';
import Popover from 'components/pure/utils/Popover';

export default class RuleAvatar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showTooltip: false,
    };
  }

  render() {
    const {owner, sessionUser} = this.props;
    return (
      <div className="avatar-wrapper">
        <span
          ref={c => (this.parent = c)}
          onMouseEnter={() => this.setState({showTooltip: true})}
          onMouseLeave={() => this.setState({showTooltip: false})}>
          <UserAvatar user={owner} />
        </span>
        {owner && <span>{owner.getDisplayName()}</span>}
        <Popover
          className="destyle-popover"
          canAutoPosition={false}
          open={this.state.showTooltip}
          useLayerForClickAway={false}
          anchorEl={this.parent}
          anchorOrigin={{
            horizontal: 'middle',
            vertical: 'top',
          }}
          targetOrigin={{
            horizontal: 'middle',
            vertical: 'bottom',
          }}>
          <div className={classnames('tooltip-container', 'tail')}>
            <div className="ev-tooltip">
              <div className="tooltip-content">
                {owner && sessionUser && sessionUser.id === owner.id && <span>Owned by you</span>}
                {owner && sessionUser && sessionUser.id !== owner.id && (
                  <span>Created by {owner.getDisplayName()}</span>
                )}
              </div>
            </div>
          </div>
        </Popover>
      </div>
    );
  }
}
